module.exports = __webpack_public_path__ + "media/images/lb/471-1fe5ccc7829bacf691a795ea69afd7bf.svg";